import { IQueryPaginationOptions } from '@/models/general';
import APIService from '../api';
import axios from 'axios';
import Vue from 'vue';
import VueAxios from 'vue-axios';

class SpecialCoinOffersService extends APIService {
  constructor() {
    Vue.use(VueAxios, axios);
    super();
  }

  get resource() {
    return `/admin/special-offer`;
  }

  get resourceV2() {
    return `/v2/admin/offer`;
  }

  getOffers(
    sortField?: string,
    sortOrder?: string,
    pagination?: string,
    filters?: string,
    params?: any,
    endpointPath?: string,
    useV2?: boolean
  ) {
    const resource = this.generateResource(
      useV2 ? `${this.resourceV2}?` : `${this.resource}?`,
      sortField ? sortField : '',
      sortOrder,
      pagination,
      filters,
      true,
      ''
    );
    return this.get(endpointPath ? endpointPath : resource, {
      params: !endpointPath && params && this.removeEmpty(params)
    });
  }

  newOffer(data: any) {
    return this.post(this.resource, data);
  }

  getOfferById(offerId: string) {
    const url = `${this.resource}/${offerId}`;
    return this.get(url);
  }

  getOffersByMethod(methods: string[]) {
    const url = `${
      this.resource
    }?method=${methods.join()}&status=active&order=DESC&sort=createdAt`;
    return this.get(url);
  }

  getOffersOverview() {
    const url = `${this.resource}/overview`;
    return this.get(url);
  }

  getOfferMembers(offerId: string, options: IQueryPaginationOptions) {
    const url = `${this.resource}/members/${offerId}`;

    return this.getQueryPagination(url, options);
  }
}

export default SpecialCoinOffersService;
